import { render, staticRenderFns } from "./NamespaceFilter.vue?vue&type=template&id=5dd62d0e&scoped=true&"
import script from "./NamespaceFilter.vue?vue&type=script&lang=js&"
export * from "./NamespaceFilter.vue?vue&type=script&lang=js&"
import style0 from "./NamespaceFilter.vue?vue&type=style&index=0&id=5dd62d0e&prod&lang=scss&scoped=true&"
import style1 from "./NamespaceFilter.vue?vue&type=style&index=1&id=5dd62d0e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd62d0e",
  null
  
)

export default component.exports